import React from "react";
import { FaUserPlus, FaClipboardList, FaBookOpen, FaChartLine, FaBolt, FaGraduationCap } from "react-icons/fa";

const journeySteps = [
  {
    title: "Register",
    description: "Create your free account",
    icon: FaUserPlus,
  },
  {
    title: "Select Exam",
    description: "Choose your target entrance exam",
    icon: FaClipboardList,
  },
  {
    title: "Practice",
    description: "Practice with tests and quizzes",
    icon: FaBookOpen,
  },
  {
    title: "Analyze Performance",
    description: "Get smart analysis and reports",
    icon: FaChartLine,
  },
  {
    title: "Improve Weak Areas",
    description: "Focus on weak topics and learn better",
    icon: FaBolt,
  },
  {
    title: "Crack Your Dream College",
    description: "Move closer to your goal",
    icon: FaGraduationCap,
  },
];

const LearningCards = () => {
  return (
    <section className="learning-journey-section" aria-labelledby="learning-journey-title">
      <div className="learning-journey-container">
        <h2 id="learning-journey-title" className="learning-journey-title">
          Your Learning Journey
        </h2>

        <div className="learning-journey-track">
          {journeySteps.map((step, index) => {
            const Icon = step.icon;

            return (
              <article className="learning-journey-card" key={step.title}>
                <span className="learning-journey-iconWrap" aria-hidden="true">
                  <Icon className="learning-journey-icon" />
                </span>

                <div className="learning-journey-cardContent">
                  <h3 className="learning-journey-cardTitle">{step.title}</h3>
                  <p className="learning-journey-cardText">{step.description}</p>
                </div>

                {index < journeySteps.length - 1 && (
                  <span className="learning-journey-connector" aria-hidden="true" />
                )}
              </article>
            );
          })}
        </div>
      </div>
    </section>
  );
};

export default LearningCards;
